import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateWorkerInput,
	createWorker,
	type UpdateWorkerInput,
	updateWorker,
} from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { Worker } from "../types";
import { toWorker } from "../utils/map";

export type SaveWorkerInput =
	| ({ workerId?: undefined } & CreateWorkerInput)
	| ({ workerId: string } & UpdateWorkerInput);

export function useSaveWorker() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (input: SaveWorkerInput): Promise<Worker> => {
			const worksiteId = activeCanteiroId as string;
			if (input.workerId != null) {
				const { workerId, ...update } = input;
				return toWorker(await updateWorker(worksiteId, workerId, update));
			}
			return toWorker(await createWorker(worksiteId, input));
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["workers"] });
			queryClient.invalidateQueries({ queryKey: ["time-entries"] });
			queryClient.invalidateQueries({ queryKey: ["attendance"] });
		},
	});
}
